import { ReactNode } from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

type Props = {
  title: string;
  children: ReactNode;
};

const useStyles = makeStyles({
  paperContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem 0.75rem',
  },
});

export function DeliveryCityCard({ title, children }: Props) {
  const classes = useStyles();

  return (
    <section>
      <h4>{title}</h4>
      <Paper className={classes.paperContent}>{children}</Paper>
    </section>
  );
}
